//node_modules
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//components
import SidebarMenu from "../../components/SidebarMenu";
import ChefManagement from './components/ChefManagement'
import MenuItems from './components/MenuItems'
import Scheduling from "./components/Scheduling";
import Stations from "./components/Stations";
import DiningOptions from "./components/DiningOptions";
import StationOptions from "./components/StationItems";
import StationMenuItem from "./components/StationMenuItem";
import Statistics from "./components/Statistics";

//styles
import * as styles from "./ManagerPortal.module.css";

function ManagerPortal() {
  return (
    <div className={styles.managerPortal}>
      <SidebarMenu
        menuItems={[
          {
            link: "/app/manager/stations",
            id: "stations",
            title: "Stations",
            icon: "pi-list",
          },
          {
            link: "/app/manager/scheduling",
            id: "scheduling",
            title: "Scheduling",
            icon: "pi-calendar-clock",
          },
          {
            link: "/app/manager/dining-options",
            id: "dining-options",
            title: "Dining options",
            icon: "pi-box",
          },
          {
            link: "/app/manager/menu-items",
            id: "menu-items",
            title: "Menu items",
            icon: "pi-cog",
          },
          {
            link: "/app/manager/chefs",
            id: "chefs",
            title: "Chefs",
            icon: "pi-user",
          },
          {
            link: "/app/manager/station-stat",
            id: "station-stat",
            title: "Statistic",
            icon: "pi-chart-line",
          },
        ]}
        title={"Manager Portal"}
      />
      <div className={styles.routeContainer}>
        <Routes>
          <Route path="stations" element={<Stations />} />
          <Route path="scheduling" element={<Scheduling />} />
          <Route path="dining-options" element={<DiningOptions />} />
          <Route path="menu-items" element={<MenuItems />} />
          <Route path="menu-items/:id" element={<StationMenuItem />} />
          <Route path="chefs" element={<ChefManagement />} />
          <Route path="station-stat" element={<Statistics />} />

          <Route index element={<Navigate to="stations" />} />
          <Route path="*" element={<Navigate to="stations" />} />
        </Routes>
      </div>
    </div>
  );
}

export default ManagerPortal;
